import React from "react";
import ApMobileAnnotationDescription from "./ApMobileAnnotationDescription";

class ApMobileAddAnnotationDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = { newAnnoType: "", newAnnoText: "" };

    this.refInputMessage = React.createRef();
  }

  componentDidUpdate() {
    if (this.refInputMessage.current) {
      this.refInputMessage.current.focus();
    }
  }

  render() {
    const { visible, mode } = this.props;

    const classes =
      "ApMobileAnnotationDescription-Group" +
      (visible ? "" : " ApMobileAnnotationDescription-Group-Hidden");

    return (
      <div className={classes}>
        {mode === "type"
          ? renderType(this.props)
          : renderMessage(this, this.props)}
      </div>
    );

    function renderType(props) {
      return (
        <div id="Container">
          <p>Anmerkung Hinzufügen</p>
          <div id="ScrollContainer">
            <div id="Group">
              <ApMobileAnnotationDescription
                type="point"
                onSelect={() => props.onSelectType("point")}
              />
              <ApMobileAnnotationDescription
                type="area"
                onSelect={() => props.onSelectType("area")}
              />
              {/*<ApMobileAnnotationDescription
                type="draw"
                onSelect={() => {} props.onSelectType("draw")}
              />*/}
            </div>
          </div>
          <p id="BackBtn" onClick={() => props.onClose()}>
            Abbrechen
          </p>
        </div>
      );
    }

    function renderMessage(context, props) {
      return (
        <div id="Container-Panel">
          <p>Schreibe etwas dazu</p>

          <textarea
            autoFocus="true"
            ref={context.refInputMessage}
            placeholder="Deine Anmerkung..."
          />

          <p id="BackBtn" onClick={() => props.onClose()}>
            Abbrechen
          </p>
          <div className="Spacer-HB" />
          <p
            id="AddBtn"
            className="Link"
            onClick={() =>
              props.onAddAnnotation(context.refInputMessage.current.value)
            }
          >
            Hinzufügen
          </p>
        </div>
      );
    }
  }
}

export default ApMobileAddAnnotationDialog;



// WEBPACK FOOTER //
// ./src/components/approval/mobile/ApMobileAddAnnotationDialog.js